import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createElementVNode as _createElementVNode } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_app_header = _resolveComponent("app-header");
  const _component_cell = _resolveComponent("cell");
  const _component_List = _resolveComponent("List");
  return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_app_header, {
    title: "运营位选择"
  }), _createElementVNode("div", null, [_createVNode(_component_List, null, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.positions, pos => {
      return _openBlock(), _createBlock(_component_cell, {
        key: pos.id,
        title: pos.nodeName,
        onClick: $event => $setup.selectPosition(pos)
      }, null, 8, ["title", "onClick"]);
    }), 128))]),
    _: 1
  })])]);
}